import { render, staticRenderFns } from "./agentdetail.vue?vue&type=template&id=d9a52fa2&"
import script from "./agentdetail.vue?vue&type=script&lang=js&"
export * from "./agentdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports